const Isotope = require('isotope-layout');
const projectList = document.querySelector('.projectList');
const filterBtns = document.querySelectorAll('.filterBtn');
const filterMessage = document.querySelector('.filterMessage');

if (projectList) {

    window.addEventListener('load', () => {
        let iso = new Isotope(projectList, {
            itemSelector: '.projectListItem',
            layoutMode: 'fitRows'
        });

        // bind filter button click
        let filtersElem = document.querySelector('.filters-button-group');
        filtersElem.addEventListener('click', ( e ) => {
            let filterValue = e.target.getAttribute('data-filter');

            iso.arrange({
                filter: filterValue
            });
        });

        for (let i = 0; i < filterBtns.length; i++) {
            filterBtns[i].addEventListener('click', () => {

                for (let j = 0; j < filterBtns.length; j++) {
                    filterBtns[j].classList.remove('active');
                }

                filterBtns[i].classList.add('active');

                filterMessage.classList.remove('active');

                iso.on('arrangeComplete', (filteredItems) => {
                    if (filteredItems.length === 0) {
                        filterMessage.classList.remove('hidden');
                    } else {
                        filterMessage.classList.add('hidden');
                    }
                });
            });
        }
    })
}